module.exports = __webpack_public_path__ + "static/media/editIcon.8828cd4d.svg";